<template>
  <div class="execution">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :key="tableKey"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="handleDel"
        @sort-change="sortChange"
      >
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-right: 20px;
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              v-if="permissions['chain:companymachineowner2:excel']"
              style="margin-right: 20px; margin-bottom: 0"
              @click="exOut"
            >
              导出
            </el-button>
            <span class="reset" @click="reset"> 重置筛选条件 </span>
          </div>
        </template>
        <template slot="waybillCount" slot-scope="scope">
          <span
            style="color: #00c5d6; cursor: pointer"
            @click="toDetail(scope.row)"
            >{{ scope.row.waybillCount }}</span
          >
        </template>
        <!-- <template slot="menuLeft" slot-scope="{ size }">
                          <el-button
                            type="primary"
                            icon="el-icon-download"
                            v-if="permissions['chain:companymachineowner2:excel']"
                            size="small"
                            :loading="tableLoading"
                            @click="exOut"
                            >导出</el-button>
                        </template> -->
        <!-- <template slot-scope="scope" slot="waybillCount">
                          <span style="color:#00c5d6;cursor:pointer;" @click="toDetail(scope.row)" v-if="scope.row.isTotalRow==0&&scope.row.isProjectTotalRow==0">{{scope.row.waybillCount}}</span>
                          <span v-else>{{scope.row.waybillCount}}</span>
                        </template> -->
        <template slot="workTimeCount" slot-scope="scope">
          <span>{{ scope.row.workTimeCount }}小时</span>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import {
  getPage,
  getObj,
  addObj,
  putObj,
  delObj,
} from "@/api/chain/companymachineowner2";
import { tableOption } from "@/const/crud/chain/companymachineowner2";
import { mapGetters } from "vuex";
import { expotOut } from "@/util/down.js";

export default {
  name: "companymachineowner2",
  data() {
    return {
      tableKey:0,
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption,
    };
  },
  created() {},
  mounted: function () {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:companymachineowner2:add"]
          ? true
          : false,
        delBtn: this.permissions["chain:companymachineowner2:del"]
          ? true
          : false,
        editBtn: this.permissions["chain:companymachineowner2:edit"]
          ? true
          : false,
        viewBtn: this.permissions["chain:companymachineowner2:get"]
          ? true
          : false,
      };
    },
  },
  methods: {
    updateTableHeight() {
        this.tableOption.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        this.tableKey += 1
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
    //   done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      if (params) {
        if (params.hasOwnProperty("searchDate")) {
          params.startTime = params.searchDate[0];
          params.endTime = params.searchDate[1];
          delete params.searchDate;
        }
      }
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done, loading) {
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    toDetail(row, type) {
      let info = {
        status: "2,3,4,11,12,21,22",
        projectInfoId: row.projectInfoId,
        machineCode: row.machineCode,
        ownerName: row.ownerName,
        shiftName: this.paramsSearch.shiftType,
        inStaffName: this.paramsSearch.inStaffName, //挖机司机 签单员
        ownerMobile: this.paramsSearch.ownerMobile, //挖机车主手机
        goDatetimeStart: this.paramsSearch.startTime,
        goDatetimeEnd: this.paramsSearch.endTime,
      };

      this.$router.push({
        path: "/chain/ledgerdig/companywaybill3",
        query: { info: JSON.stringify(info) },
      });
    },
    exOut() {
      let params = Object.assign({}, this.paramsSearch);
      if (params) {
        if (params.hasOwnProperty("searchDate")) {
          params.startTime = params.searchDate[0];
          params.endTime = params.searchDate[1];
          delete params.searchDate;
        }
      }
      this.tableLoading = true;
      let url = "/chain/companymachineowner/exportExcel";
      // params.id = this.info.id
      expotOut(params, url, "挖机车主统计")
        .then(() => {
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
/deep/.avue-crud__menu{
    display: none;
}
.headerContent{
  margin-left: 105px;
}
</style>
